import * as generalTypes from 'constants/ActionTypes';
import * as types from 'modules/interventions/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsOpenState */

/** @type {IsOpenState} */
const initialState = false;

/**
 * @returns {IsOpenState}
 */
const open = () => true;

/**
 * @returns {IsOpenState}
 */
const close = () => false;

export default createReducer(initialState, {
  [types.OPEN_SEND_MODAL]: open,
  [types.CLOSE_SEND_MODAL]: close,
  [types.SEND_INTERVENTION_SUCCESS]: close,
});
